import CollectionsIcon from '@mui/icons-material/Collections';
import { useState } from 'react';

import { EstadosImagenChoiceEnum } from '@/shared';
import { SingleIconButton } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import FotosEntradaUpdatedReviewModal from './FotosEntradaUpdatedReviewModal';
import FotosSalidaUpdatedReviewModal from './FotosSalidaUpdatedReviewModal';

export type FotosCorregidasCellActivacionProps = {
  ordenTrabajo: OrdenTrabajo;
};

const FotosCorregidasCellActivacion: React.FC<
  FotosCorregidasCellActivacionProps
> = ({ ordenTrabajo }) => {
  const [isOpenFotosEntradaModal, setIsOpenFotosEntradaModal] = useState(false);
  const [isOpenFotosSalidaModal, setIsOpenFotosSalidaModal] = useState(false);

  return (
    <>
      {/* ========= btns ========= */}
      {ordenTrabajo?.estado_imagen_entrada ===
        EstadosImagenChoiceEnum.UPD_REALIZADA && (
        <SingleIconButton
          startIcon={<CollectionsIcon />}
          color="info"
          label={'Revisar Fotos Entrada'}
          onClick={() => {
            setIsOpenFotosEntradaModal(true);
          }}
        />
      )}

      {ordenTrabajo?.estado_imagen_salida ===
        EstadosImagenChoiceEnum.UPD_REALIZADA && (
        <SingleIconButton
          startIcon={<CollectionsIcon />}
          color="primary"
          label={'Revisar Fotos Salida'}
          onClick={() => {
            setIsOpenFotosSalidaModal(true);
          }}
        />
      )}

      {/* ========= Modals ========= */}
      <FotosEntradaUpdatedReviewModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenFotosEntradaModal}
        onClose={() => {
          setIsOpenFotosEntradaModal(false);
        }}
      />

      <FotosSalidaUpdatedReviewModal
        ordenTrabajo={ordenTrabajo!}
        open={isOpenFotosSalidaModal}
        onClose={() => {
          setIsOpenFotosSalidaModal(false);
        }}
      />
    </>
  );
};

export default FotosCorregidasCellActivacion;
